import { makeUrl } from './makeUrl';
import { handleResponse } from './response';

export interface DelegatedAccessTokenParams {
    participantID: string;
    clientID: string;
    clientSecret: string;
    /** Access token forwarded when running in embedded (app) mode. */
    accessToken?: string;
}

export interface DelegatedAccessTokenResponse {
    access_token: string;
    token_type: string;
    expires_in: number;
    scope: string;
}

/**
 * Exchanges credentials for a delegated participant access token via the
 * identityserver/connect/token endpoint. Uses form-encoded body as required
 * by the OAuth token endpoint.
 */
export async function getDelegatedAccessToken(
    params: DelegatedAccessTokenParams,
): Promise<DelegatedAccessTokenResponse> {
    const body = new URLSearchParams({
        grant_type: 'delegated_participant',
        participant_id: params.participantID,
        client_id: params.clientID,
        client_secret: params.clientSecret,
        scope: 'api user/*.read',
    });
    if (params.accessToken) {
        body.set('token', params.accessToken);
    }

    return fetch(makeUrl('identityserver/connect/token'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
        body: body.toString(),
    }).then(response => handleResponse(response));
}